import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const GENERAL_CONSULT_CONSTANTS = {
  id: 'general.consult',
  title: 'Consulta',

  labels: {
    ...COMMONS,
    actual: 'Consulta Actual'
  },

  actions: {
    ...ACTIONS,
    editPatient: 'Editar información de paciente',
    draft: 'Borrador',
    generateHistory: 'Generar Historia'
  }
};
